import { render, staticRenderFns } from "./ConfirmDeleteDialog.vue?vue&type=template&id=2d891a6e&scoped=true&"
import script from "./ConfirmDeleteDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDeleteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d891a6e",
  null
  
)

export default component.exports